import React, { useState, useEffect, useRef } from 'react';
import './Notifications.css';
import NotificationsList from './components/NotificationsList';
import { useAuth } from '../../../contexts/AuthContext';
import axios from 'axios';
import { getScenarioContent, getTemplatePrefix } from '../Constants/paymentScenarios';

const Notifications = ({ activeData }) => {
  const { token } = useAuth();
  
  const paymentScenario = activeData || null;
  console.log('Notifications - Received paymentScenario:', paymentScenario);

  // Use constants instead of hardcoded logic
  const scenarioContent = getScenarioContent(paymentScenario);
  const scenarioPrefix = getTemplatePrefix(paymentScenario);

  console.log('Notifications activeData:', activeData);
  console.log('Notifications scenarioPrefix:', scenarioPrefix);

  // State for toggles - matching Dashboard pattern
  const [toggles, setToggles] = useState({
    notification: true,
  });

  const [templates, setTemplates] = useState([]);
  const [blockStates, setBlockStates] = useState({});
  const [notificationBlockStates, setNotificationBlockStates] = useState({});
  const triggerSaveData = useRef(false);
  const [reloadTemplates, setReloadTemplates] = useState(false);

  // Template name logic with scenario prefix - matching Dashboard pattern
  const template_name = scenarioPrefix === 'current-payment' 
    ? 'gardenwall-notification' 
    : `gardenwall-notification-${scenarioPrefix}`;
    
  console.log('Notifications Template name:', template_name);

  const handleBlockStatesChange = (newBlockStates) => {
    setBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  const handleNotificationBlockStatesChange = (newBlockStates) => {
    setNotificationBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  // Function to toggle on/off switches - matching Dashboard
  const handleToggle = (section) => {
    setToggles((prev) => ({ ...prev, [section]: !prev[section] }));
    triggerSaveData.current = true;
  };

  // Auto-save trigger - matching Dashboard pattern
  useEffect(() => {
    if (triggerSaveData.current) {
      saveData();
      triggerSaveData.current = false;
    }
  }, [toggles, blockStates, notificationBlockStates]);

  // Fetch templates function - matching Dashboard
  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/templates/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      return [];
    }
  };

  // Load templates on mount - matching Dashboard
  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchTemplates();
      setTemplates(fetchedTemplates);
    };

    loadTemplates();
  }, []);

  // Reload templates effect - matching Dashboard
  useEffect(() => {
    if (reloadTemplates) {
      const loadTemplates = async () => {
        const fetchedTemplates = await fetchTemplates();
        setTemplates(fetchedTemplates);
        setReloadTemplates(false);
      };
  
      loadTemplates();
    }
  }, [reloadTemplates]);

  // Apply template data when templates are loaded - matching Dashboard
  useEffect(() => {
    if (templates && templates.length > 0) {
      console.log('Notifications Templates updated:', templates);
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate) {
        try {
          const template_data = JSON.parse(
            JSON.parse(specificTemplate.template)
          );
          setToggles(template_data.toggles || {
            notification: true,
          });
          setBlockStates(template_data.blockStates || {});
          setNotificationBlockStates(template_data.notificationBlockStates || {});
        } catch (error) {
          console.error('Error parsing template data:', error);
        }
      } else {
        console.log('Notifications specific template not found');
      }
    }
  }, [templates, template_name]);

  // Save data function - matching Dashboard pattern
  const saveData = async () => {
    const formData = new FormData();
    formData.append('template_name', template_name);
    formData.append(
      'template',
      JSON.stringify({
        toggles,
        blockStates,
        notificationBlockStates,
        scenarioData: paymentScenario
      })
    );
    
    console.log('Notifications - Saving template with name:', template_name);

    const urlBase = `${process.env.REACT_APP_BASE_URL}/templates`;
    let url = `${urlBase}/create`;
    let method = 'post';

    if (templates && templates.length > 0) {
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate && specificTemplate.id) {
        url = `${urlBase}/update/${specificTemplate.id}`;
        method = 'put';
      }
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      });
      console.log('Notifications Response Data:', response.data); 
      if (method === 'post') {
        setReloadTemplates(true);
      }

    } catch (error) {
      console.error('Error saving notifications template:', error);
    }
  };

  return (
    <div className="notification">
      <div className="notification-main">
        {/* Notifications Header with Payment Scenario Status */}
        <h1 className="notification-header">
          Notifications – <span className={scenarioContent.headerClass}>{scenarioContent.headerStatus}</span>
        </h1>

        <div className="notification-grid">
          {/* Notifications Card */}
          <div className={`card col-4 get-notification ${!toggles.notification ? 'card-disabled' : ''}`}>
            <div className="card-header">
              Notifications
              <div className="custom-toggle" onClick={() => handleToggle('notification')}>
                <input type="checkbox" checked={toggles.notification} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <NotificationsList 
              scenarioData={paymentScenario}
              onBlockStatesChange={handleBlockStatesChange}
              onNotificationBlockStatesChange={handleNotificationBlockStatesChange}
              blockStates={blockStates}
              notificationBlockStates={notificationBlockStates}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;

